import { useActionDraftSpeakerRefine } from "hook/draft/dialog/useActionDraftSpeaker";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setDraftDialogSpeakers } from "store/bailiff/draft/dialog/draft_dialog.action";
//
//component
//redux
//selector
//actions
const TriggerSpeakers = () => {
  // -------------------------- VAR ----------------------------
  const { data } = useActionDraftSpeakerRefine();
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    if (data?.length > 0) {
      dispatch(setDraftDialogSpeakers(data));
    }
  }, [dispatch, data]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerSpeakers;
